  const mainCategories = document.querySelectorAll(".main-category");
  const childLinks = document.querySelectorAll(".mega-menu__link--level-2");
  const mainContent = document.querySelector(`#MainContent`);
  const closeButton = document.querySelectorAll(".submenu__close-button");
  const grandChildLinks = document.querySelectorAll(
    ".mega-menu__link--level-3"
  );
  const megaMenuContents = document.querySelectorAll(".mega-menu__content");
  const allContentContainers = document.querySelectorAll(".mega-menu-container");
  const allBackgrounds = document.querySelectorAll(".fixed-mega-overlay");
  const allNestedMenus = document.querySelectorAll(".nested-menu");

  const closeAllMenus = () => {
    document.body.classList.remove('overflow-hidden'); 
    mainContent.classList.remove("mega-menu-active", "nested-open");
    mainCategories.forEach((cat) => cat.classList.remove("active"));
    allContentContainers.forEach((content) => {
        content.removeAttribute("open");     
    }); 
    megaMenuContents.forEach((content) => {
      content.removeAttribute("open");
      content.style.display = "none";
    }); 
    allNestedMenus.forEach((content) => {
      content.removeAttribute("open");
    }); 
    allBackgrounds.forEach((content) => {
      content.classList.remove('open');
    }); 
  };

 function getHiddenElementHeight(el) {
    el.style.display = "block";  
    let height = el.offsetHeight; 
    el.style.display = "";    
    return height;
};

 function getHiddenSubElementHeight(sub) {
    sub.style.display = "block"; 
    let height = sub.offsetHeight;
    sub.style.display = "";    
    return height;
};

  closeButton.forEach((button) => {
      button.addEventListener("click", (e) => {
      e.preventDefault();
      const parentDetails = button.closest(".nested-menu");
      const subMenu = button.closest(".nested-submenus");
      const category = button.closest(".mega-menu__content");
      const categoryIndex = category.getAttribute("data-category-index");
      const contentContainer = document.querySelector(
        `#mega-menu-container-${categoryIndex}`
      );  
      const menuContent = document.querySelector(
        `#MegaMenu-Content-${categoryIndex}`
      );
      if(getHiddenElementHeight(menuContent) >= 650){
        mainCategorieHeight = getHiddenElementHeight(menuContent) - 250 + 'px';
      }else{
        mainCategorieHeight = 400 + 'px';
      }
      contentContainer.style.height = mainCategorieHeight;
      menuContent.setAttribute("open", ""); 
      subMenu.classList.add('closing');
      setTimeout(() => {   
        subMenu.classList.remove('closing');
        parentDetails.removeAttribute("open");
      }, 400);        
    });    
  });

  mainCategories.forEach((category) => {
    category.addEventListener("click", (e) => {
      e.preventDefault();
      const categoryIndex = category.getAttribute("data-category-index");
      const contentContainer = document.querySelector(
        `#mega-menu-container-${categoryIndex}`
      );
      const menuContent = document.querySelector(
        `#MegaMenu-Content-${categoryIndex}`
      );        
      const background = document.querySelector(
        `#fixed-mega-overlay-${categoryIndex}`
      );
      if (menuContent) {
        const hasSubcategories = menuContent.querySelector(
          ".mega-menu__list > li"
        );        
        closeAllMenus();
        document.body.classList.add('overflow-hidden'); 
        if (hasSubcategories) {
          if(getHiddenElementHeight(menuContent) >= 650){
            mainCategorieHeight = getHiddenElementHeight(menuContent) - 250 + 'px';
          }else{
            mainCategorieHeight = 400 + 'px';
          }
          const isVisible = menuContent.hasAttribute("open");
          menuContent.style.display = "flex";           
          if (!isVisible) {                      
            contentContainer.setAttribute("open", "");
            menuContent.setAttribute("open", "");
            category.classList.add("active");      
            background.classList.add('open');
            contentContainer.style.height = mainCategorieHeight;
          }
        } else {
          const link = category.getAttribute("data-href");
          if (link) {
            window.location.href = link;
          }
        }
      } else {
        const link = category.getAttribute("data-href");
        if (link) {
          window.location.href = link;
        } else {
          console.warn(
            "Kein Link gefunden für Hauptkategorie ohne Menüinhalte."
          );
        }
      }
    });
  });

  childLinks.forEach((childLink) => {
    childLink.addEventListener("click", (e) => {     
      e.preventDefault();      
      const parentDetails = childLink.closest(".nested-menu");
      const parentIndex = parentDetails.getAttribute("data-category-index");
      const category = childLink.closest(".mega-menu__content");
      const categoryIndex = category.getAttribute("data-category-index");
      const menuContent = document.querySelector(
        `#MegaMenu-Content-${categoryIndex}`
      );
      const menuContainer = document.querySelector(
        `#mega-menu-container-${categoryIndex}`
      );
      const background = document.querySelector(
        `#fixed-mega-overlay-${categoryIndex}`
      );
      const subMenuContainer = document.getElementById(
        `nested-submenu-${categoryIndex}-${parentIndex}`
      );
      const summaryElement = e.currentTarget;      
      
      const hasGrandChildren = parentDetails.querySelector(
          "ul.nested-menu__content"
        );
        if (hasGrandChildren) {
            subCategorieHeight = getHiddenSubElementHeight(subMenuContainer) + 50 + 'px';
            const summarySibling = summaryElement.nextElementSibling;
            Shopify.theme.trapFocus(
              summarySibling,
              parentDetails.querySelector("button")
            );
          const isOpen = parentDetails.hasAttribute("open");
          if (isOpen) {
            parentDetails.removeAttribute("open");
            menuContent.setAttribute("open", "");            
          } else {    
            menuContainer.style.height = subCategorieHeight;
            parentDetails.setAttribute("open", "");   
            menuContent.removeAttribute("open"); 
        }
        } else {
          const subLink = document.getElementById(
          `mega-menu-sublink-${categoryIndex}-${parentIndex}`
          );
          window.location.href = subLink.href;
        }
    });
  });

  grandChildLinks.forEach((grandChildLink) => {
    grandChildLink.addEventListener("click", () => {
      window.location.href = grandChildLink.href;
    });
  });

  document.addEventListener("click", (e) => {
    if (
      !e.target.closest(".mega-menu__content") &&
      !e.target.closest(".main-category")
    ) {
      closeAllMenus();
    }
  });
